export default __webpack_public_path__ + "static/brain_heart_sm-55a7a54e3e9af090518fd7016fecb4b0.png";